import { render, staticRenderFns } from "./manage-booking-receipt-parkings-my-account.vue?vue&type=template&id=22d54256&scoped=true"
import script from "./manage-booking-receipt-parkings-my-account.vue?vue&type=script&lang=ts"
export * from "./manage-booking-receipt-parkings-my-account.vue?vue&type=script&lang=ts"
import style0 from "./manage-booking-receipt-parkings-my-account.vue?vue&type=style&index=0&id=22d54256&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d54256",
  null
  
)

export default component.exports